import { all, call, put, select, takeEvery } from 'redux-saga/effects'

import { getBasketCallSaga } from 'components/Basket/saga'
import { startLoading, stopLoading } from 'components/Loader/LoaderPopup/reducer'
import { setErrorMessage } from 'components/Windows/CentralMessagesList/reducer'
import { callApiAsync } from 'services/api/callAPIAsync'
import { API_LANGUAGE_MAPPING } from '../../global/i18n/constants'
import { localeSelector } from '../../global/i18n/selectors'
import { changeTicketCategory } from './reducer'

function* changeTicketCategoryCallSaga(action) {
    const { payload } = action
    const { id, ticketId } = payload

    const language = API_LANGUAGE_MAPPING?.[yield select(localeSelector)] ?? null

    if (_.isNil(id) || _.isNil(ticketId)) return

    yield put(startLoading())
    const { error } = yield call(callApiAsync, 'changeTicketCategory', {
        customer_categoryid: id,
        ticketId,
        language,
    })

    if (error) {
        console.error(error)
        yield put(setErrorMessage(error))
        yield put(stopLoading())
        return
    }

    yield call(getBasketCallSaga)
    yield put(stopLoading())
}
export default function* yourOrderSaga() {
    yield all([takeEvery(changeTicketCategory.type, changeTicketCategoryCallSaga)])
}
